import { type FC, type ReactNode } from 'react';

import { stopPropagation } from '@/packages/utils/event/stopPropagation';

import styles from './ContactActionsLayout.css';

type ContactActionsLayoutProps = {
  joinElectronicTradingButton: ReactNode;
  phoneButton: ReactNode;
  chatButton: ReactNode;
  showMoreOffers: ReactNode;
};

export const ContactActionsLayout: FC<ContactActionsLayoutProps> = props => {
  const { joinElectronicTradingButton, phoneButton, chatButton, showMoreOffers } = props;

  return (
    <div className={styles['container']} onClick={stopPropagation}>
      {showMoreOffers}
      {joinElectronicTradingButton || phoneButton}
      {chatButton}
    </div>
  );
};
